import * as actionTypes from "../constants/actionTypes";
import * as methods from "../constants/methods";
import * as handlers from "../constants/handlers";

export const isOnlineActivationAvailableForWizard = () => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_ONLINE_LICENSE_ACTIVATION_AVAILABLE
    },
    method: handlers.ONLINE_ACTIVATION_AVAILABLE_FOR_LICENSE_WIZARD,
    tabId: 0
});

export const isOnlineActivationAvailable = () => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_ONLINE_LICENSE_ACTIVATION_AVAILABLE
    },
    method: handlers.ONLINE_LICENSE_ACTIVATION_AVAILABLE,
    tabId: 0
});

export const updateLicense = () => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_ONLINE_LICENSE_UPDATE
    },
    method: handlers.ONLINE_LICENSE_UPDATE,
    tabId: 0
});

export const setLicenseIdentification = (companyId, userId) => ({
    type: actionTypes.LICENSE_SET_IDENTIFICATION,
    payload: {
        companyId: companyId,
        userId: userId
    }
});

export const setProduct = (product) => ({
    type: actionTypes.LICENSE_SET_PRODUCT,
    payload: {
        product: product
    }
});

export const setData = (data) => ({
    type: actionTypes.LICENSE_SET_DATA,
    payload: {
        data: data
    }
});

export const removeLicenseRequest = () => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_REMOVE_LICENSE_REQUEST
    },
    method: handlers.REMOVE_LICENSE_REQUEST,
    tabId: 0
});

export const installLicense = (license) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_INSTALL_LICENSE,
        params: {
            license: license
        }
    },
    method: handlers.INSTALL_LICENSE,
    tabId: 0
});

export const saveRegistrationForm = (registrationData) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_SET_REGISTRATION_DATA,
        params: {
            value: {
                Machine: {
                    SerialNumber: registrationData.machineSerialNumber,
                    Type: registrationData.machineType,
                    Producer: registrationData.machineProducer,
                    NumberOfCanisters: registrationData.machineNumberOfCanisters
                },
                ContactPerson: {
                    Phone: registrationData.contactPhone,
                    Name: registrationData.contactName,
                    Email: registrationData.contactEmail
                },
                PointOfSale: {
                    City: registrationData.posCity,
                    Name: registrationData.posName,
                    Zip: registrationData.posZip,
                    Country: registrationData.posCountry,
                    Region: registrationData.posRegion,
                    Street: registrationData.posStreet
                }
            }
        }
    },
    method: handlers.SET_REGISTRATION_DATA,
    tabId: 0
});

export const setStep = (step) => ({
    type: actionTypes.LICENSE_SET_PROCESS_STEP,
    payload: {
        step: step
    }
});

export const refresh = () => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_AVAILABLE_LICENSE_PRODUCTS_ORDERED
    },
    method: handlers.GET_AVAILABLE_LICENSE_PRODUCTS_ORDERED,
    tabId: 0
});

export const logOutAndReactivate = () => ({
    type: actionTypes.LOG_OUT_AND_REACTIVATE
});
